import { FC } from 'react';

import OrgSettings from '@/pages/OrgSettings';
import TeamSettings from '@/pages/TeamSettings';
import Workspace from '@/pages/WorkspaceTeams';
import { BasetenPageEnum } from '@/routes/types';
import asyncComponentLoader from '@/utils/react/loader';

const PageComponents: Partial<Record<BasetenPageEnum, FC>> = {
  [BasetenPageEnum.Workspace]: Workspace,
  [BasetenPageEnum.WorkspaceTeams]: Workspace,
  [BasetenPageEnum.TeamSettings]: TeamSettings,
  [BasetenPageEnum.Settings]: OrgSettings,
  [BasetenPageEnum.DeployModel]: asyncComponentLoader(() => import('@/pages/DeployModel')),
  [BasetenPageEnum.Model]: asyncComponentLoader(() => import('@/pages/Model')),
  [BasetenPageEnum.Chain]: asyncComponentLoader(() => import('@/pages/Chain')),
  [BasetenPageEnum.SharedEndpoint]: asyncComponentLoader(() => import('@/pages/SharedEndpoint')),
  [BasetenPageEnum.TrainingProject]: asyncComponentLoader(() => import('@/pages/Training')),
  [BasetenPageEnum.Onboarding]: asyncComponentLoader(() => import('@/pages/Onboarding')),
  [BasetenPageEnum.Playground]: asyncComponentLoader(() => import('@/pages/Playground')),
  [BasetenPageEnum.CreateSharedEndpoint]: asyncComponentLoader(
    () => import('@/pages/CreateSharedEndpoint'),
  ),
};

export default PageComponents;
